import { API } from "aws-amplify";
import { ValidNioxStatusReport } from "../../containers/Kiosk/NioxFeno/types";
import { NioxInstrumentInfoReport, NioxMeasurement } from "../../Types/Common/NioxFeno";
import { store } from "../../redux/store";
import { FenoDeviceSerialNumber, OrganizationID, PatientID, ProviderID } from "../../Types/Common/BrandedTypes";
import { CollectionID, FenoMeasurement, MeasurementPOSTBody } from "../../Types/Common/MeasurementTypes";
import { NioxFenoServiceType, UploadNioxFenoInstrumentInfoReportBody, UploadNioxFenoStatusReportBody, UploadNioxFenoMeasurementBody, RequestNioxFenoMeasurementUploadBody } from "../../Types/Common/API/niox-feno-kiosk";
import { RoundtripTime } from "../../Types/Common/DateTypes";
import { OrgConsentLabel } from "../../Types/Common/Types";
import { getTimezoneOffsetInMilliseconds } from "../utilsLib";
import { createMeasurement } from "../trialsLib";

const API_NAME = 'v2';
const API_PATH = '/niox-feno-kiosk';

export const getCommonMetadata = () => {
  const { kiosk } = store.getState().kiosk;
  const { sessionID } = store.getState().nioxFeno;

  return {
    kioskID: kiosk?.kioskID,
    sessionID,
    timeNowUTC: new Date().toISOString(),
    timezoneName: Intl.DateTimeFormat().resolvedOptions().timeZone,
    timezoneOffsetMs: getTimezoneOffsetInMilliseconds()
  };
};

export const uploadNioxFenoInstrumentInfoReport = async (instrumentInfoReport: NioxInstrumentInfoReport) => {
  const service: NioxFenoServiceType = "instrumentInfoReport";
  const body: UploadNioxFenoInstrumentInfoReportBody = {
    instrumentInfoReport,
    ...getCommonMetadata()
  };

  try {
    await API.post(API_NAME, `${API_PATH}/${service}`, {
      body
    });
  } catch (error) {
    console.error(`error uploading niox feno instrument info report: ${error}`);
  }
};

export const uploadNioxFenoStatusReport = async (fenoDeviceSerialNumber: FenoDeviceSerialNumber, statusReport: ValidNioxStatusReport) => {
  const service: NioxFenoServiceType = "statusReport";
  const body: UploadNioxFenoStatusReportBody = {
    fenoDeviceSerialNumber,
    statusReport,
    ...getCommonMetadata()
  };

  try {
    await API.post(API_NAME, `${API_PATH}/${service}`, {
      body
    });
  } catch (error) {
    console.error(`error uploading niox feno status report: ${error}`);
  }
};

export const uploadNioxFenoMeasurement = async (body: UploadNioxFenoMeasurementBody) => {
  const service: NioxFenoServiceType = "measurement";
  try {
    const response: FenoMeasurement = await API.post(API_NAME, `${API_PATH}/${service}`, {
      body
    });
    return response;
  } catch (error) {
    console.error(`error uploading niox feno measurement: ${error}`);
  }
};

export const requestNioxFenoMeasurementUpload = async (selectedPatientID: PatientID, measurement: NioxMeasurement, note: string) => {
  const service: NioxFenoServiceType = "requestUploadMeasurement";
  const body: RequestNioxFenoMeasurementUploadBody = {
    patientID: selectedPatientID,
    measurement,
    note,
    ...getCommonMetadata()
  };

  try {
    await API.post(API_NAME, `${API_PATH}/${service}`, {
      body
    });
    return true;
  } catch (error) {
    console.error(`error uploading niox feno request measurement upload form: ${error}`);
    return false;
  }
};


export const createFenoLabelsMeasurement = async (patientID: PatientID, roundtripTime: RoundtripTime, providerID: ProviderID, collectionID: CollectionID, labels?: Record<OrganizationID, [OrgConsentLabel['label'], ...OrgConsentLabel['label'][]] | undefined>) => {
  const body: MeasurementPOSTBody = {
    patientID,
    type: 'LABELSFE',
    roundtripTime,
    providerID,
    collectionID,
    labels
  };

  return await createMeasurement(body);
}